import { render } from "./Kidsee.vue?vue&type=template&id=56371ee8"
import script from "./Kidsee.vue?vue&type=script&lang=js"
export * from "./Kidsee.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__